import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=4f6d941e&scoped=true&"
import script from "./AppDrawer.vue?vue&type=script&lang=ts&"
export * from "./AppDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d941e",
  null
  
)

export default component.exports